import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Box,
  Button,
  Center,
  Paper,
  PasswordInput,
  Text,
  TextInput,
  Title,
} from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { adminLogin } from '../api'
import { useAuth } from '../AuthContext'

export default function LoginPage() {
  const navigate = useNavigate()
  const { login } = useAuth()
  const [form, setForm] = useState({ login: '', password: '' })
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!form.login || !form.password) return
    setLoading(true)
    try {
      const data = await adminLogin(form.login, form.password)
      login(data.token)
      navigate('/admin/services', { replace: true })
    } catch (err) {
      notifications.show({ color: 'red', title: 'Ошибка', message: 'Неверный логин или пароль' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Center h="100vh">
      <Paper shadow="sm" p="xl" w={360} radius="md" withBorder>
        <Title order={3} mb="xs" ta="center">
          Moscow Garage
        </Title>
        <Text c="dimmed" size="sm" ta="center" mb="xl">
          Панель управления
        </Text>
        <Box component="form" onSubmit={handleSubmit}>
          <TextInput
            label="Логин"
            placeholder="admin"
            mb="md"
            value={form.login}
            onChange={(e) => setForm((f) => ({ ...f, login: e.target.value }))}
            required
          />
          <PasswordInput
            label="Пароль"
            placeholder="••••••••"
            mb="xl"
            value={form.password}
            onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
            required
          />
          <Button type="submit" fullWidth loading={loading}>
            Войти
          </Button>
        </Box>
      </Paper>
    </Center>
  )
}
